<template>
  <div class="sentence-controls">
    <div class="sentence bold" v-if="$store.state.isMobile">
      <div class="fragment">Show me images</div>
    </div>
    <div class="sentence" v-if="!$store.state.isMobile">
      <div class="fragment">Show me images from</div>
      <div class="control years">
        <TagList
          :values="$store.state.years"
          :label="yearTag ? yearTag.value : 'all years'"
          category="year"
          @changed="$emit('changed')"
          :categorize="false"
          :valueCounts="$store.getters.yearCounts"
          :invert="false"
          :index="yearTag ? yearTag.index : -1"
        />
      </div>
      <div class="fragment">tagged with</div>
      <div class="tags-include">
        <fragment v-for="(t, i) in tags" :key="'tag' + t.index">
          <div
            :class="{
              control: true,
              empty: t.value === ''
            }"
          >
            <PredictiveTyper
              @changed="$emit('changed')"
              category="tag"
              :categorize="true"
              :fulllist="$store.getters.tags"
              :showall="true"
              :placeholder="t ? t.value : ''"
              :index="t ? t.index : -1"
              :valueCounts="$store.getters.tagCounts"
              :invert="false"
            />
          </div>
          <div class="fragment" v-if="i < tags.length - 2">
            ,
          </div>
          <div class="fragment" v-if="i === tags.length - 2">
            and
          </div>
        </fragment>
      </div>
      <div class="fragment">.</div>
      <div
        class="add"
        @click="adding = 'tags'"
        v-if="!adding && tags && tags[0].value !== ''"
      >
        <img :src="addImagePath" />
      </div>
    </div>
    <div class="sentence" v-if="$store.state.isMobile">
      <div class="fragment">From</div>
      <div class="control years">
        <TagList
          :values="$store.state.years"
          :label="yearTag ? yearTag.value : 'all years'"
          category="year"
          @changed="$emit('changed')"
          :categorize="false"
          :valueCounts="$store.getters.yearCounts"
          :invert="false"
          :index="yearTag ? yearTag.index : -1"
        />
      </div>
    </div>

    <div class="sentence" v-if="$store.state.isMobile">
      <div class="fragment">Tagged with</div>
      <fragment v-for="t in tags" :key="'tag' + t.index">
        <div
          :class="{
            control: true,
            'tags-include': true,
            empty: t.value === ''
          }"
        >
          <PredictiveTyper
            @changed="$emit('changed')"
            category="tag"
            :categorize="true"
            :fulllist="$store.getters.tags"
            :showall="true"
            :placeholder="t ? t.value : ''"
            :index="t ? t.index : -1"
            :valueCounts="$store.getters.tagCounts"
            :invert="false"
          />
        </div>
      </fragment>
      <div
        class="add"
        @click="adding = 'tags'"
        v-if="!adding && tags && tags[0].value !== ''"
      >
        <img :src="addImagePath" />
      </div>
    </div>
    <div class="sentence" v-if="!$store.state.isMobile">
      <div class="fragment">
        Don't show images tagged with
      </div>
      <fragment v-for="(t, i) in invertTags" :key="'tag' + t.index">
        <div
          :class="{
            control: true,
            empty: t.value === ''
          }"
        >
          <PredictiveTyper
            @changed="$emit('changed')"
            category="tag"
            :categorize="true"
            :fulllist="$store.getters.tags"
            :showall="true"
            :placeholder="t ? t.value : ''"
            :index="t ? t.index : -1"
            :valueCounts="$store.getters.tagCounts"
            :invert="true"
          />
        </div>
        <div class="fragment" v-if="i < invertTags.length - 2">
          ,
        </div>
        <div class="fragment" v-if="i === invertTags.length - 2">
          or
        </div>
      </fragment>
      <div class="fragment">
        .
      </div>
      <div
        class="add"
        @click="adding = 'invert'"
        v-if="!adding && invertTags && invertTags[0].value !== ''"
      >
        <img :src="addImagePath" />
      </div>
    </div>
    <div class="sentence" v-if="$store.state.isMobile">
      <div class="fragment">
        Not tagged with
      </div>
      <fragment v-for="t in invertTags" :key="'tag' + t.index">
        <div
          :class="{
            control: true,
            empty: t.value === ''
          }"
        >
          <PredictiveTyper
            @changed="$emit('changed')"
            category="tag"
            :categorize="true"
            :fulllist="$store.getters.tags"
            :showall="true"
            :placeholder="t ? t.value : ''"
            :index="t ? t.index : -1"
            :valueCounts="$store.getters.tagCounts"
            :invert="true"
          />
        </div>
      </fragment>
      <div
        class="add"
        @click="adding = 'invert'"
        v-if="!adding && invertTags && invertTags[0].value !== ''"
      >
        <img :src="addImagePath" />
      </div>
    </div>
    <div class="sentence sentence-ocr">
      <div class="fragment" v-if="!$store.state.isMobile">
        Only include images that contain the text
      </div>
      <div class="fragment" v-else>Containing the text</div>
      <div class="control">
        <PredictiveTyper
          @changed="$emit('changed')"
          category="ocr"
          :fulllist="$store.getters.ocr"
          :placeholder="ocrTag ? ocrTag.value : ''"
          :index="ocrTag ? ocrTag.index : -1"
          :valueCounts="$store.getters.ocrCounts"
        />
      </div>
      <div class="fragment">.</div>
    </div>
  </div>
</template>

<script>
import TagList from "../components/TagList";
import PredictiveTyper from "../components/PredictiveTyper";
import { getAssetPath } from "@/constants/constants";

export default {
  name: "MadLibs",
  components: {
    TagList,
    PredictiveTyper
  },
  methods: {
    removeFilter(i) {
      this.$store.dispatch("removeFilter", i);
      this.numImages = 20;
    }
  },
  data() {
    return {
      adding: false
    };
  },
  computed: {
    addImagePath() {
      return getAssetPath("/assets/add.svg");
    },

    yearTag() {
      if (!this.$store.state.filters) return false;
      let year = false;
      this.$store.state.filters.forEach((v, i) => {
        if (v.category === "year") {
          year = {
            ...v,
            index: i
          };
        }
      });
      return year;
    },

    ocrTag() {
      if (!this.$store.state.filters) return false;
      let ocr = false;
      this.$store.state.filters.forEach((v, i) => {
        if (v.category === "ocr") {
          ocr = {
            ...v,
            index: i
          };
        }
      });
      return ocr;
    },

    filters() {
      return this.$store.state.filters;
    },

    tags() {
      let tags = [];

      for (let i = 0; i < this.filters.length; i++) {
        if (
          this.$store.state.filters[i].category === "tag" &&
          !this.$store.state.filters[i].invert
        ) {
          tags.push({
            ...this.$store.state.filters[i],
            index: i
          });
        }
      }

      if (tags.length === 0 || this.adding === "tags") {
        tags.push({
          type: "tag",
          index: -1,
          value: ""
        });
      }

      return tags;
    },

    invertTags() {
      let tags = [];

      for (let i = 0; i < this.$store.state.filters.length; i++) {
        if (
          this.$store.state.filters[i].category === "tag" &&
          this.$store.state.filters[i].invert
        ) {
          tags.push({
            ...this.$store.state.filters[i],
            index: i
          });
        }
      }

      if (tags.length === 0 || this.adding === "invert") {
        tags.push({
          type: "tag",
          index: -1,
          value: ""
        });
      }

      return tags;
    }
  },

  watch: {
    filters() {
      this.adding = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.control {
  height: 28px;
  &.empty {
    min-width: 150px;

    @media (max-width: 815px) {
      min-width: 100px;
    }
  }

  display: inline-block;
  margin: 0em 0.25em;
}

.sentence {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0.5em 0em;

  &:last-child {
    margin-bottom: 0em;
  }

  @media (max-width: 815px) {
    justify-content: flex-start;
    margin-left: 0px;
  }

  @media (max-width: 815px) and (orientation: landscape) {
    margin: 0.25em 0em;
  }
}

.tags-include {
  align-items: flex-end;
  display: flex;
}

.sentence-controls {
  margin-left: 1em;
  margin-top: -0.5em;

  @media (max-width: 815px) {
    margin-left: 0px;
  }

  @media (max-width: 815px) and (orientation: landscape) {
    display: flex;
    flex-wrap: wrap;

    .sentence:not(:first-child) {
      margin-left: 0.25em;
      text-transform: lowercase;
    }
  }
}

.add {
  margin-left: 0.25em;
  cursor: pointer;

  &:hover {
    filter: brightness(65%) contrast(400%);
  }
}

.bold {
  margin-top: 1em;
}
</style>
